export default "__VITE_ASSET__YRcOF702__"